import { render, staticRenderFns } from "./LinearSections.vue?vue&type=template&id=56b72ffc&"
import script from "./LinearSections.vue?vue&type=script&lang=js&"
export * from "./LinearSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports